import type { MouseEvent } from "react";

export interface MovieCardMovie {
  id: string;
  title: string;
  poster: string;
  year: number;
  genres: string[];
  rating: number;
}

interface MovieCardProps {
  movie: MovieCardMovie;
  onOpen: (id: string) => void;
  rank?: number;
}

export default function MovieCard({ movie, onOpen, rank }: MovieCardProps) {
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    onOpen(movie.id);
  };

  return (
    <a
      href={`/detail/${movie.id}`}
      onClick={handleClick}
      className="group block cursor-pointer"
      title={`${movie.title}（${movie.year}）高清在线观看`}
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-200">
        <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg">
          <img
            src={movie.poster}
            alt={`${movie.title} 电影海报`}
            title={`${movie.title} ${movie.year} 免费在线观看`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          {typeof rank === "number" && (
            <span className="absolute left-0 top-0 flex h-8 w-8 items-center justify-center rounded-br-lg bg-accent-500 text-sm font-bold text-background-50 font-heading">
              {rank}
            </span>
          )}
          <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-foreground-950/70 px-1.5 py-0.5 text-xs font-semibold text-accent-400 font-heading">
            <i className="ri-star-fill text-[10px]" />
            {movie.rating.toFixed(1)}
          </span>
          <div className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center pb-3 transition-transform duration-300 group-hover:translate-y-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-play-fill text-lg" />
            </span>
          </div>
        </div>
      </div>
      <h3 className="mt-2 truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
        {movie.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-600">
        {movie.year} · {movie.genres.slice(0, 2).join(" ")}
      </p>
    </a>
  );
}